import React, { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const MODULE_STYLE = {
  Leave:      "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  Attendance: "text-blue-400 bg-blue-500/10 border-blue-500/20",
  Payroll:    "text-purple-400 bg-purple-500/10 border-purple-500/20",
  Ticket:     "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  Profile:    "text-white/50 bg-white/5 border-white/10",
};

export default function ApprovalsHub({ loading: loadingProp, data }) {
  const [items,    setItems]    = useState(data?.pending || []);
  const [comments, setComments] = useState({});
  const [busy,     setBusy]     = useState(null);

  // Sync if data prop updates
  useEffect(() => { if (data?.pending) setItems(data.pending); }, [data]);

  const setComment = (id, val) => setComments(c => ({ ...c, [id]: val }));

  const act = async (id, action) => {
    setBusy(id + action);
    try {
      const token = localStorage.getItem("token");
      await fetch(`${API_BASE}/api/admin/approvals/${id}/${action}`, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ comment: comments[id] || "" }),
      });
    } finally {
      setItems(prev => prev.map(x => x.id === id ? { ...x, status: action === "approve" ? "APPROVED" : "REJECTED" } : x));
      setBusy(null);
    }
  };

  if (loadingProp) return (
    <div className={`${card} p-5`}>
      <div className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium mb-4">Approvals Hub</div>
      <div className="space-y-2">{[1,2,3].map(i => <div key={i} className="h-14 rounded-lg bg-white/5 animate-pulse" />)}</div>
    </div>
  );

  const pending = items.filter(x => !x.status);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Approvals Hub</span>
        {pending.length > 0 && (
          <span className="text-xs text-yellow-400 bg-yellow-500/10 border border-yellow-500/20 px-2 py-0.5 rounded-full">
            {pending.length} pending
          </span>
        )}
      </div>

      <div className="p-4 space-y-2">
        {items.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-4">No pending approvals.</p>
        ) : (
          items.map(x => {
            const moduleStyle = MODULE_STYLE[x.module] || MODULE_STYLE.Profile;
            const decided = x.status;
            return (
              <div key={x.id} className="rounded-lg border border-white/5 bg-white/3 px-4 py-3">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className={`text-xs px-2 py-0.5 rounded-full border ${moduleStyle}`}>{x.module}</span>
                      <span className="text-sm text-white/70">{x.what}</span>
                    </div>
                    <p className="text-xs text-white/30">Owner: {x.owner}</p>
                  </div>

                  {decided ? (
                    <span className={`text-xs px-2 py-0.5 rounded-full border shrink-0 ${
                      decided === "APPROVED"
                        ? "text-[#00ff90]/60 bg-[#00ff90]/5 border-[#00ff90]/20"
                        : "text-red-400/60 bg-red-500/5 border-red-500/20"
                    }`}>{decided}</span>
                  ) : (
                    <div className="flex items-center gap-2 shrink-0 flex-wrap">
                      <input
                        placeholder="Comment…"
                        value={comments[x.id] || ""}
                        onChange={e => setComment(x.id, e.target.value)}
                        className="bg-black border border-white/10 rounded-lg px-2 py-1 text-xs text-white outline-none w-28 focus:border-[#00ff90]/30 transition-colors"
                      />
                      <button onClick={() => act(x.id, "approve")} disabled={busy !== null}
                        className="text-xs px-2.5 py-1 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] disabled:opacity-40 transition-colors">
                        ✓
                      </button>
                      <button onClick={() => act(x.id, "reject")} disabled={busy !== null}
                        className="text-xs px-2.5 py-1 rounded-lg border border-red-500/25 bg-red-500/8 text-red-400/70 hover:bg-red-500/15 hover:text-red-400 disabled:opacity-40 transition-colors">
                        ✗
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}